import React from 'react';
import { formatNumberWithCommas } from '../../../utils/util';

export const QueryResultAggregator = (sum: number, avg: number) => {
    return (
        <div className="query-result-aggregator">
            <span>{'Sum: ' + formatNumberWithCommas(sum) }</span>
            <br />
            <span>{'Avg: ' + formatNumberWithCommas(avg) }</span>
            
        </div>
    );
};


